// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file user/user_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file user/user_requests.proto.
 */
export const file_user_user_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chh1c2VyL3VzZXJfcmVxdWVzdHMucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IiQKEVVzZXJzQnlJZHNSZXF1ZXN0Eg8KB3VzZXJJZHMYASADKAMiFwoVR2V0U2VsZlByb2ZpbGVSZXF1ZXN0IrUCChRVcGRhdGVQcm9maWxlUmVxdWVzdBIQCghuaWNrbmFtZRgCIAEoCRIWCglhdmF0YXJVcmwYAyABKAlIAIgBARISCgVwaG9uZRgEIAEoCUgBiAEBEhIKBWVtYWlsGAUgASgJSAKIAQESFQoIcG9zaXRpb24YBiABKAlIA4gBARIWCglmaXJzdE5hbWUYByABKAlIBIgBARIVCghsYXN0TmFtZRgIIAEoCUgFiAEBEhcKCm1pZGRsZU5hbWUYCSABKAlIBogBARITCgtkaXNwbGF5TmFtZRgKIAEoCUIMCgpfYXZhdGFyVXJsQggKBl9waG9uZUIICgZfZW1haWxCCwoJX3Bvc2l0aW9uQgwKCl9maXJzdE5hbWVCCwoJX2xhc3ROYW1lQg0KC19taWRkbGVOYW1lIigKF0dldFVzZXJzQnlFbWFpbHNSZXF1ZXN0Eg0KBWVtYWlsGAEgAygJQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.UsersByIdsRequest
 */
export type UsersByIdsRequest = Message<'com.gem.bff.contract.UsersByIdsRequest'> & {
  /**
   * @generated from field: repeated int64 userIds = 1;
   */
  userIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.UsersByIdsRequest.
 * Use `create(UsersByIdsRequestSchema)` to create a new message.
 */
export const UsersByIdsRequestSchema: GenMessage<UsersByIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_user_user_requests, 0);

/**
 * @generated from message com.gem.bff.contract.GetSelfProfileRequest
 */
export type GetSelfProfileRequest = Message<'com.gem.bff.contract.GetSelfProfileRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetSelfProfileRequest.
 * Use `create(GetSelfProfileRequestSchema)` to create a new message.
 */
export const GetSelfProfileRequestSchema: GenMessage<GetSelfProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_user_user_requests, 1);

/**
 * @generated from message com.gem.bff.contract.UpdateProfileRequest
 */
export type UpdateProfileRequest = Message<'com.gem.bff.contract.UpdateProfileRequest'> & {
  /**
   * @generated from field: string nickname = 2;
   */
  nickname: string;

  /**
   * @generated from field: optional string avatarUrl = 3;
   */
  avatarUrl?: string;

  /**
   * @generated from field: optional string phone = 4;
   */
  phone?: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email?: string;

  /**
   * @generated from field: optional string position = 6;
   */
  position?: string;

  /**
   * @generated from field: optional string firstName = 7;
   */
  firstName?: string;

  /**
   * @generated from field: optional string lastName = 8;
   */
  lastName?: string;

  /**
   * @generated from field: optional string middleName = 9;
   */
  middleName?: string;

  /**
   * @generated from field: string displayName = 10;
   */
  displayName: string;
};

/**
 * Describes the message com.gem.bff.contract.UpdateProfileRequest.
 * Use `create(UpdateProfileRequestSchema)` to create a new message.
 */
export const UpdateProfileRequestSchema: GenMessage<UpdateProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_user_user_requests, 2);

/**
 * @generated from message com.gem.bff.contract.GetUsersByEmailsRequest
 */
export type GetUsersByEmailsRequest = Message<'com.gem.bff.contract.GetUsersByEmailsRequest'> & {
  /**
   * @generated from field: repeated string email = 1;
   */
  email: string[];
};

/**
 * Describes the message com.gem.bff.contract.GetUsersByEmailsRequest.
 * Use `create(GetUsersByEmailsRequestSchema)` to create a new message.
 */
export const GetUsersByEmailsRequestSchema: GenMessage<GetUsersByEmailsRequest> =
  /*@__PURE__*/
  messageDesc(file_user_user_requests, 3);
